<template>
  <div class="text-center">
    <b-row no-gutters align-v="center" align-h="center">
      <b-col cols="12" align-self="center" class="p-3 bg-warning-light font-weight-bold"
        ><b-link :href="`${baseLocaleUrl()}/order/${orderId}/store/tags/pet/${pet.id}`" class="text-secondary"
          ><u>{{ $t('components.petFooter.chooseTagForNextPet', { petName: pet.name }) }}</u></b-link
        ></b-col
      >
    </b-row>
  </div>
</template>

<script>
import baseLocaleUrl from '@/mixins/baseLocaleUrl';

export default {
  mixins: [baseLocaleUrl],
  props: {
    pet: {
      type: Object,
      required: true,
    },
    orderId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.bg-warning-light {
  background-color: $dp-light-yellow;
}
</style>
